export class Sensor {
  data?: SensorData
}

export class SensorData extends Sensor {
  type?: string
  id?: string | null | number
  attributes?: SensorDataAttributes
  relationships?: SensorDataRelationshipsData
}

export class SensorDataAttributes extends SensorData {
  active?: boolean;
  address?: string;
  serial?: string;
  firmware?: boolean | string;
  reset?: boolean;
  stop?: boolean;
  lat?: string;
  lng?: string;
  last_value?: boolean;
  last_updated?: string;
  last_x?: string;
  last_y?: string;
  last_z?: string;
  name?: string;
  status_battery?: boolean
  status_user?: boolean
  status_user_auth?: boolean
}

export class SensorDataRelationshipsData extends SensorData {
  group?: {
    data?: {
      type?: string;
      id?: groupID;
    }
  }
  block?: {
    data?: {
      type?: string;
      id?: blockID;
    }
  }
}

export type groupID = null | string;
export type blockID = null | string;

export default Sensor
